webpackJsonp([36733297554888],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(26);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(45);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(44);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(77);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(76);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "" : _props$transitionDela;
	
	  return "<img width=" + width + " height=" + height + " src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;objectPosition:center\"/>";
	};
	
	var Img = function Img(props) {
	  var opacity = props.opacity,
	      onLoad = props.onLoad,
	      _props$transitionDela2 = props.transitionDelay,
	      transitionDelay = _props$transitionDela2 === undefined ? "" : _props$transitionDela2,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["opacity", "onLoad", "transitionDelay"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: {
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      transitionDelay: transitionDelay,
	      opacity: opacity,
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }
	  }));
	};
	
	Img.propTypes = {
	  opacity: _propTypes2.default.number,
	  transitionDelay: _propTypes2.default.string,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden",
	              zIndex: 1
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        zIndex: 1,
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            zIndex: 0,
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.35s"
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            opacity: !this.state.imgLoaded ? 1 : 0,
	            transitionDelay: "0.25s"
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = OptimizedImage;
	
	var _gatsbyImage = __webpack_require__(100);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function OptimizedImage(_ref) {
	  var _props;
	
	  var image = _ref.image,
	      defaultImage = _ref.defaultImage,
	      _ref$type = _ref.type,
	      type = _ref$type === undefined ? 'sizes' : _ref$type,
	      other = _objectWithoutProperties(_ref, ['image', 'defaultImage', 'type']);
	
	  if (!image) {
	    return _react2.default.createElement('img', _extends({ src: defaultImage, alt: '' }, other));
	  }
	  var props = (_props = {}, _props[type] = image.childImageSharp[type], _props);
	  return _react2.default.createElement(_gatsbyImage2.default, _extends({}, props, other, { backgroundColor: '#CCCCCC' }));
	}
	module.exports = exports['default'];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Pagination;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Pagination(_ref) {
	  var _ref$data = _ref.data,
	      first = _ref$data.first,
	      last = _ref$data.last,
	      index = _ref$data.index,
	      pageCount = _ref$data.pageCount,
	      pathPrefix = _ref$data.pathPrefix;
	
	  if (pageCount === 1) {
	    return null;
	  }
	  return _react2.default.createElement(
	    'ul',
	    { className: 'pagination' },
	    _react2.default.createElement(
	      'li',
	      { className: first ? 'disabled' : 'waves-effect' },
	      _react2.default.createElement(
	        'a',
	        {
	          href: first ? '#' : index === 2 ? '/' + pathPrefix : '/' + pathPrefix + '/' + (index - 1)
	        },
	        _react2.default.createElement('i', { className: 'fa fa-chevron-left' })
	      )
	    ),
	    Array(pageCount).fill(0).map(function (_, i) {
	      return i + 1;
	    }).map(function (idx) {
	      return _react2.default.createElement(
	        'li',
	        { className: idx === index ? 'active' : 'waves-effect', key: idx },
	        _react2.default.createElement(
	          'a',
	          { href: idx === 1 ? '/' + pathPrefix : '/' + pathPrefix + '/' + idx },
	          idx
	        )
	      );
	    }),
	    _react2.default.createElement(
	      'li',
	      { className: last ? 'disabled' : 'waves-effect' },
	      _react2.default.createElement(
	        'a',
	        { href: last ? '#' : '/' + pathPrefix + '/' + (index + 1) },
	        _react2.default.createElement('i', { className: 'fa fa-chevron-right' })
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Sidebar;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptimizedImage = __webpack_require__(42);
	
	var _OptimizedImage2 = _interopRequireDefault(_OptimizedImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Sidebar(_ref) {
	  var _ref$latestPosts = _ref.latestPosts,
	      latestPosts = _ref$latestPosts === undefined ? [] : _ref$latestPosts;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'col s12 l4 left-align sidebar' },
	    _react2.default.createElement(
	      'ul',
	      { className: 'collection with-header m-t-3' },
	      _react2.default.createElement(
	        'li',
	        { className: 'collection-header' },
	        _react2.default.createElement(
	          'h5',
	          null,
	          'Latest Posts'
	        )
	      ),
	      latestPosts.map(function (_ref2) {
	        var _ref2$node = _ref2.node,
	            id = _ref2$node.id,
	            excerpt = _ref2$node.excerpt,
	            _ref2$node$frontmatte = _ref2$node.frontmatter,
	            title = _ref2$node$frontmatte.title,
	            featuredImage = _ref2$node$frontmatte.featuredImage,
	            path = _ref2$node$frontmatte.path;
	        return _react2.default.createElement(
	          'li',
	          { className: 'collection-item avatar', key: id },
	          _react2.default.createElement(
	            'a',
	            { href: path },
	            _react2.default.createElement(
	              'div',
	              { style: { position: 'absolute', left: 0 } },
	              _react2.default.createElement(_OptimizedImage2.default, {
	                image: featuredImage,
	                defaultImage: 'http://placehold.it/42x42',
	                alt: '',
	                className: 'circle',
	                type: 'resolutions'
	              })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'title' },
	              title
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              excerpt
	            )
	          )
	        );
	      })
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = SimpleHeader;
	
	__webpack_require__(50);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SimpleHeader(_ref) {
	  var title = _ref.title;
	
	  return _react2.default.createElement(
	    'header',
	    { id: 'main-header', className: 'blog-main-header gradient-color' },
	    _react2.default.createElement('div', { className: 'overlay gradient-color' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      _react2.default.createElement(
	        'h2',
	        { className: '' },
	        title
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _OptimizedImage = __webpack_require__(42);
	
	var _OptimizedImage2 = _interopRequireDefault(_OptimizedImage);
	
	var _SimpleHeader = __webpack_require__(43);
	
	var _SimpleHeader2 = _interopRequireDefault(_SimpleHeader);
	
	var _Sidebar = __webpack_require__(75);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Pagination = __webpack_require__(206);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function FeaturedImage(_ref) {
	  var id = _ref.id,
	      posts = _ref.posts;
	
	  var post = posts.find(function (p) {
	    return p.node.id === id;
	  });
	  var featuredImage = post && post.node.frontmatter.featuredImage;
	  return _react2.default.createElement(_OptimizedImage2.default, {
	    image: featuredImage,
	    style: { display: 'block' },
	    className: 'responsive-img',
	    defaultImage: 'http://placehold.it/410x270',
	    alt: 'blog image'
	  });
	}
	
	function BlogPage(_ref2) {
	  var _ref2$data = _ref2.data,
	      latestPosts = _ref2$data.latestPosts,
	      posts = _ref2$data.posts,
	      pathContext = _ref2.pathContext;
	  var group = pathContext.group;
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog' },
	    _react2.default.createElement(_SimpleHeader2.default, { title: 'Our Blog' }),
	    _react2.default.createElement(
	      'section',
	      {
	        id: 'news',
	        'data-scroll-index': '4',
	        className: 'main-section center-align'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col s12 l8' },
	            _react2.default.createElement(
	              'div',
	              { className: 'p-t-2 grid center-align row' },
	              group.map(function (_ref3) {
	                var _ref3$node = _ref3.node,
	                    id = _ref3$node.id,
	                    excerpt = _ref3$node.excerpt,
	                    frontmatter = _ref3$node.frontmatter;
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'single-news col s12 m6', key: id },
	                  _react2.default.createElement(
	                    'a',
	                    { href: frontmatter.path },
	                    _react2.default.createElement(
	                      'figure',
	                      null,
	                      _react2.default.createElement(FeaturedImage, { id: id, posts: posts.edges }),
	                      _react2.default.createElement(
	                        'figcaption',
	                        null,
	                        _react2.default.createElement('span', {
	                          className: 'overlay gradient-color',
	                          style: { height: '100%' }
	                        }),
	                        _react2.default.createElement(
	                          'span',
	                          { className: 'stats' },
	                          _react2.default.createElement(
	                            'span',
	                            { className: 'search' },
	                            _react2.default.createElement('i', { className: 'fa fa-search' })
	                          )
	                        )
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'info p-b-1' },
	                    _react2.default.createElement(
	                      'p',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('i', {
	                          className: 'fa fa-user gradient-color',
	                          'aria-hidden': 'true'
	                        }),
	                        frontmatter.author
	                      ),
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        _react2.default.createElement('i', {
	                          className: 'fa fa-calendar gradient-color',
	                          'aria-hidden': 'true'
	                        }),
	                        frontmatter.date
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      { href: frontmatter.path },
	                      _react2.default.createElement(
	                        'h5',
	                        null,
	                        frontmatter.title
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'p',
	                      { className: 'p-b-1' },
	                      excerpt
	                    ),
	                    _react2.default.createElement(
	                      'a',
	                      {
	                        href: frontmatter.path,
	                        className: 'shadow-button waves-effect waves-light'
	                      },
	                      'Read more',
	                      _react2.default.createElement('i', { className: 'fa fa-arrow-right' })
	                    )
	                  )
	                );
	              })
	            ),
	            _react2.default.createElement(_Pagination2.default, { data: pathContext })
	          ),
	          _react2.default.createElement(_Sidebar2.default, { latestPosts: latestPosts.edges })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { id: 'subscribe', className: 'main-section center-align' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'subscribe-container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col s12 l4' },
	            _react2.default.createElement(
	              'h4',
	              { className: 'title p-b-2' },
	              'Subscribe'
	            )
	          ),
	          _react2.default.createElement(
	            'form',
	            {
	              id: 'subscribe-form',
	              name: 'subscribe-form',
	              className: 'subscribe-input input-field col s12 l8'
	            },
	            _react2.default.createElement('input', {
	              name: 'subscribe-email',
	              id: 'subscribe-email',
	              type: 'email',
	              className: 'validate'
	            }),
	            _react2.default.createElement(
	              'label',
	              { 'data-error': 'Invalid Email', htmlFor: 'subscribe-email' },
	              'Email'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                id: 'subscribe-submit',
	                className: 'gradient-color waves-effect waves-light',
	                type: 'submit'
	              },
	              _react2.default.createElement('i', { className: 'fa fa-paper-plane first' }),
	              _react2.default.createElement('i', { className: 'fa fa-paper-plane second' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'input-field col s12 hidden' },
	              _react2.default.createElement('input', {
	                type: 'text',
	                id: 'subscribe-check-spam',
	                placeholder: 'Leave field empty',
	                name: 'check-spam'
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('div', {
	          className: 'col s12 alert-message p-t-2',
	          id: 'subscribe-alert-message'
	        })
	      )
	    )
	  );
	}
	
	exports.default = BlogPage;
	
	// cannot use childImageSharp from `createPages`:
	// https://github.com/gatsbyjs/gatsby/issues/2628#issuecomment-375242484
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-js-7e3f53dcceab6919757e.js